var React = require('react');

function ChartPie (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.987 18c.597 0 1.088.524 1.004 1.116a14.969 14.969 0 0 1-4.571 8.804c-.388.366-1.009.335-1.387-.042l-9.877-9.877h14.831zm-.99-4.05c.039.57-.441 1.05-1.012 1.05H16.999V1.015c0-.571.48-1.052 1.05-1.012 7.466.515 13.433 6.481 13.948 13.947zM14 18l9.741 9.742c.428.428.396 1.155-.098 1.505a14.885 14.885 0 0 1-8.454 2.752C7.177 32.1.281 25.532.008 17.523-.257 9.725 5.436 3.218 12.884 2.166c.591-.084 1.115.407 1.115 1.004v14.831z"}));
}

ChartPie.defaultProps = {"viewBox":"0 0 34 32"};

module.exports = ChartPie;

ChartPie.default = ChartPie;
